@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as c;
@use "styles/abstracts/mixins/common" as m;

.selectContainer {
  width: 100%;
}

.menuAnchor {
  position: fixed;
  z-index: v.$z-index-select-portal;
  pointer-events: none;
}

.menuPortalDropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  min-width: 100%;
  pointer-events: auto;
}

.select {
  svg {
    display: block;
  }

  .singleValue {
    display: flex;
    align-items: center;
    height: 43px;
    padding: 0 14px;
    gap: 8px;
    flex-shrink: 0;

    .valueLabel {
      @include t.text(14px, 22px, 400);
      color: v.$palette-gray-900;
      white-space: nowrap;
    }

    .valueIcon {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 20px;
    }
  }

  .multiValue {
    display: flex;
    align-items: center;
    height: 43px;
    padding: 0 14px;
    @include t.text(14px, 22px, 400);
    color: v.$palette-gray-900;
  }

  .placeholder {
    display: flex;
    align-items: center;
    height: 43px;
    padding: 0 16px;
    @include t.text(14px, 22px, 400);
    color: v.$palette-dirty-70;
  }

  .input {
    display: flex;
    align-items: center;
    height: 43px;
    padding: 0 16px;
    @include t.text(14px, 22px, 400);
    color: v.$palette-gray-900;
    flex-shrink: 0;

    &.isMulti {
      position: relative;
      display: inline-grid;
      height: auto;
    }

    &.isMulti.isNonEmpty {
      padding: 0;
    }
  }

  .option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 38px;
    padding: 11px 12px;
    gap: 8px;
    border-radius: 8px;
    flex-shrink: 0;
    cursor: pointer;

    &.isSelected {
      background: v.$palette-dirty-10;
    }

    &.isFocused {
      background: v.$palette-orange-4;
      color: v.$palette-orange-2;

      .valueLabel {
        color: v.$palette-orange-2;
      }

      svg path {
        fill: v.$palette-orange-2;
      }
    }

    &.isSelected.isFocused {
      background: v.$palette-orange-4;
    }

    .valueLabel {
      @include t.text(14px, 22px, 400);
      color: v.$palette-gray-900;
      white-space: nowrap;
    }

    .valueIcon {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 20px;
    }

    .textWrap {
      display: flex;
      gap: 8px;
      overflow: hidden;
    }

    .optionActions {
      display: flex;
      align-items: center;
      gap: 6px;

      .action {
        position: relative;
        right: -3px;
      }
    }
  }

  .dropDownIndicator {
    display: flex;
    align-items: center;
    padding: 0px 16px;
  }

  .menuListContainer {
    padding: 4px;
  }

  @keyframes selectFadeIn {
    0% {
      max-height: 0;
      opacity: 0;
      transform: translateY(-20px);
    }
    25% {
      opacity: 0;
      transform: translateY(-15px);
    }
    100% {
      max-height: 150px;
      opacity: 1;
      transform: translateY(0);
    }
  }

  .menu {
    z-index: v.$z-index-select-dropdown;
    animation: selectFadeIn 300ms ease-in-out;
    @include c.scrollbar();
    overflow: hidden;
  }

  .menuRelative {
    position: relative;
  }

  :global {
    .react-select {
      &__control {
        cursor: pointer;
        height: 48px;
        border-radius: 8px;
        background: v.$palette-white;
        border: 1px solid v.$palette-dirty-50;

        &.react-select__control--is-focused {
          border-color: v.$palette-orange-1;
          box-shadow: none;
        }
      }

      &__input-container {
        margin: 0;
      }

      &__value-container {
        padding: 0;
        margin: 0;
      }

      &__dropdown-indicator {
        transform: rotate(180deg);
        padding: 0;
      }

      &__indicator-separator {
        display: none;
      }

      &__option {
        padding: 0;
        background: none;

        &:active {
          background: none;
        }
      }

      &__menu {
        padding: 0;
        margin: 0;
        border-radius: 8px;
        box-shadow: v.$shadow2;
      }

      &__menu-list {
        padding: 4px;
        border: none;
      }
    }

    .react-select__control--menu-is-open .react-select__dropdown-indicator {
      transform: rotate(0deg);
    }
  }
}
